/* CURRENCIES */
export const GET_CURRENCIES = "GET_CURRENCIES"
export const GET_CURRENCIES_SUCCESS = "GET_CURRENCIES_SUCCESS"
export const GET_CURRENCIES_FAIL = "GET_CURRENCIES_FAIL"
